import {THMANYAH_DISPLAY, THMANYAH_SANS} from '#/state/postStyle/fonts'

export function thmanyahWebSources(): Record<string, number> {
  return {
    [THMANYAH_DISPLAY.regular]: require('../../../assets/fonts/thmanyah/thmanyahserifdisplay-Regular.woff2'),
    [THMANYAH_DISPLAY.bold]: require('../../../assets/fonts/thmanyah/thmanyahserifdisplay-Bold.woff2'),
    [THMANYAH_DISPLAY.black]: require('../../../assets/fonts/thmanyah/thmanyahserifdisplay-Black.woff2'),
    [THMANYAH_SANS.medium]: require('../../../assets/fonts/thmanyah/thmanyahsans-Medium.woff2'),
  }
}

export function getThmanyahSources(): Record<string, number> {
  return thmanyahWebSources()
}
